<template>
    <div class="text-xs-center">
        <v-menu v-model="menu" left bottom :close-on-content-click="false" offset-x transition="scale-transition">
            <v-btn slot="activator" dark icon @click="$router.push('/notifications/dashboard')">
                <v-icon>notifications_active</v-icon>
            </v-btn>
        </v-menu>
    </div>
</template>

<script>
import NotificationDashboard from '@/components/common/notifications/notification-dashboard';

    export default {
        data: () => ({
            fav: true,
            menu: false,
            message: false,
            hints: true,
            items: NotificationDashboard
        }),
        methods: {
            ShowNotifications() {
                let self = this;
                self.menu = false
                self.$router.push('/notifications/dashboard');
            }
        }
    }
</script>

<style>

</style>